import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { WhiteLabelStore } from '../stores/whiteLabelStore';
import { WhiteLabelConfigStore } from '../stores/whiteLabelConfigStore';

export const useWhiteLabelStore = () => useContext<{
  whiteLabelStore: WhiteLabelStore;
  whiteLabelConfigStore: WhiteLabelConfigStore;
}>(StoreContext);
